import { jsx as _jsx } from "react/jsx-runtime";
function initialsOf(name) {
    if (name === undefined)
        return '?';
    const trimmed = name.trim();
    if (trimmed.length === 0)
        return '?';
    const initials = trimmed
        .split(/\s+/)
        .map((part) => part[0] ?? '')
        .filter((c) => c.length > 0)
        .slice(0, 2)
        .join('')
        .toUpperCase();
    return initials.length === 0 ? '?' : initials;
}
function hueFor(name) {
    if (name === undefined || name.length === 0)
        return 220;
    const sum = Array.from(name).reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    return 220 + ((sum % 6) * 30 % 60);
}
export function Avatar({ name, size = 32 }) {
    const initials = initialsOf(name);
    const hue = hueFor(name);
    return (_jsx("div", { "aria-hidden": "true", className: "inline-flex items-center justify-center rounded-full font-bold text-white shrink-0", style: {
            // ADR frontend-0002 exemption 1: JS-calculated values (size,
            // hash-derived hue) stay inline. Layout/typography classes
            // come from Tailwind above.
            width: size,
            height: size,
            fontSize: Math.round(size * 0.42),
            background: `oklch(0.72 0.04 ${hue})`,
        }, children: initials }));
}
//# sourceMappingURL=Avatar.js.map